import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=fff63f16&scoped=true&"
import script from "./newsDetail.vue?vue&type=script&lang=js&"
export * from "./newsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=fff63f16&prod&lang=css&"
import style1 from "./newsDetail.vue?vue&type=style&index=1&id=fff63f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff63f16",
  null
  
)

export default component.exports